import React, { useState } from 'react';
import { Drawer, Form, Input, Button, DatePicker, message } from 'antd';
import dayjs from 'dayjs';
import { usePermissions } from "../../../../custom_hooks/permission/permission_hook";

import { AttachDelivery } from "../../../../components/delivery/attach_delivery";
import { AttachLRDrawer } from "../../../../components/delivery/attach_lr_drawer";
import { AttachPODDrawer } from "../../../../components/delivery/attach_pod_drawer";
import DeliveryLocationDrawer from "../../../../components/delivery/delivery_location_drawer";
import EWayBillDrawer from "../../../../components/delivery/eway_bill_drawer";
import { LoginextCSVUpload } from "../../../../components/delivery/loginext_csv_upload";
import WarehouseSelectionDrawer from "../../../../components/delivery/warehouse_selection_drawer";
import { ItemsDrawer } from "../../../../components/misc/items_drawer";
import { editDelivery } from "../deliveryApi";
import { EscalationDrawer } from "./EscalationDrawer";

interface DeliveryModalsProps {
  attachDeliveryDrawerVisible: number | null;
  setAttachDeliveryDrawerVisible: (val: number | null) => void;
  attachPODDrawerVisible: any;
  setAttachPODDrawerVisible: (val: any) => void;
  attachLRDrawerVisible: any;
  setAttachLRDrawerVisible: (val: any) => void;
  warehouseDrawerVisible: boolean;
  setWarehouseDrawerVisible: (val: boolean) => void;
  onWarehouseFinish: (values: any) => void;
  delivery_location_drawer_visible: boolean;
  setDeliveryLocationDrawerVisible: (val: boolean) => void;
  onDeliveryDetailsFinish: (values: any) => void;
  eway_bill_drawer_visible: boolean;
  setEwayBillDrawerVisible: (val: boolean) => void;
  onEwayBillDetailsFinish: (values: any) => void;
  itemsToView: any[];
  setItemsToView: (items: any[]) => void;
  showLoginextCSVUpload: boolean;
  setShowLoginextCSVUpload: (val: boolean) => void;
  fetchDeliveries: (params: any) => void;
  po_data: any;
  vendor_name?: string;
  porterLinkDrawerData: any;
  setPorterLinkDrawerData: (data: any) => void;
  onPorterLinkFinish: (vals: { location_link: string; vehicle_number: string; driver_number: string }) => void;
  dispatchTimeDrawerVisible: any;
  setDispatchTimeDrawerVisible: (val: any) => void;
  escalationDrawerData: any;
  setEscalationDrawerData: (val: any) => void;
}

export const DeliveryModals = ({
  attachDeliveryDrawerVisible,
  setAttachDeliveryDrawerVisible,
  attachPODDrawerVisible,
  setAttachPODDrawerVisible,
  attachLRDrawerVisible,
  setAttachLRDrawerVisible,
  warehouseDrawerVisible,
  setWarehouseDrawerVisible,
  onWarehouseFinish,
  delivery_location_drawer_visible,
  setDeliveryLocationDrawerVisible,
  onDeliveryDetailsFinish,
  eway_bill_drawer_visible,
  setEwayBillDrawerVisible,
  onEwayBillDetailsFinish,
  itemsToView,
  setItemsToView,
  showLoginextCSVUpload,
  setShowLoginextCSVUpload,
  fetchDeliveries,
  po_data,
  vendor_name,
  porterLinkDrawerData,
  setPorterLinkDrawerData,
  onPorterLinkFinish,
  dispatchTimeDrawerVisible,
  setDispatchTimeDrawerVisible,
  escalationDrawerData,
  setEscalationDrawerData,
}: DeliveryModalsProps) => {
  const { hasPermission } = usePermissions();
  const [porterLinkForm] = Form.useForm();
  const [dispatchTimeForm] = Form.useForm();

  return (
    <>
      <Drawer
        title="Attach Delivery"
        open={!!attachDeliveryDrawerVisible}
        onClose={() => setAttachDeliveryDrawerVisible(null)}
      >
        {attachDeliveryDrawerVisible && (
          <AttachDelivery
            poId={attachDeliveryDrawerVisible}
            onClose={() => setAttachDeliveryDrawerVisible(null)}
          />
        )}
      </Drawer>

      <Drawer
        title="Attach POD"
        open={!!attachPODDrawerVisible}
        onClose={() => setAttachPODDrawerVisible(null)}
      >
        {attachPODDrawerVisible && (
          <AttachPODDrawer
            delivery={attachPODDrawerVisible}
            onClose={() => {
              setAttachPODDrawerVisible(null);
              fetchDeliveries({ keepCurrentSearch: true, page: 1 });
            }}
          />
        )}
      </Drawer>

      <Drawer
        title="Attach LR"
        open={!!attachLRDrawerVisible}
        onClose={() => setAttachLRDrawerVisible(null)}
      >
        {attachLRDrawerVisible && (
          <AttachLRDrawer
            delivery={attachLRDrawerVisible}
            onClose={() => {
              setAttachLRDrawerVisible(null);
              fetchDeliveries({ keepCurrentSearch: true, page: 1 });
            }}
          />
        )}
      </Drawer>
      <WarehouseSelectionDrawer
        visible={warehouseDrawerVisible}
        onClose={() => setWarehouseDrawerVisible(false)}
        onFinish={onWarehouseFinish}
      />
      <DeliveryLocationDrawer
        visible={delivery_location_drawer_visible}
        onClose={() => setDeliveryLocationDrawerVisible(false)}
        onFinish={onDeliveryDetailsFinish}
        vendor_name={vendor_name}
      />
      <EWayBillDrawer
        visible={eway_bill_drawer_visible}
        onClose={() => setEwayBillDrawerVisible(false)}
        onFinish={onEwayBillDetailsFinish}
      />
      <ItemsDrawer
        items={itemsToView}
        open={itemsToView.length > 0}
        onClose={() => setItemsToView([])}
      />
      
      <Drawer
        title="Loginext CSV Upload"
        open={showLoginextCSVUpload}
        onClose={() => setShowLoginextCSVUpload(false)}
        width={700}
      >
        {showLoginextCSVUpload && (
          <LoginextCSVUpload
            onClose={() => setShowLoginextCSVUpload(false)}
          />
        )}
      </Drawer>

      <Drawer
        title="Enter Porter / Tracking Link"
        open={!!porterLinkDrawerData}
        onClose={() => { setPorterLinkDrawerData(null); porterLinkForm.resetFields(); }}
        width={400}
      >
        <Form
          form={porterLinkForm}
          layout="vertical"
          onFinish={(vals) => {
            onPorterLinkFinish({ location_link: vals.location_link, vehicle_number: vals.vehicle_number, driver_number: vals.driver_number });
            setPorterLinkDrawerData(null);
            porterLinkForm.resetFields();
          }}
        >
          <Form.Item
            name="location_link"
            label="Porter / Tracking Link"
            rules={[{ required: true, message: "Please enter the tracking link" }]}
          >
            <Input placeholder="https://porter.in/track/..." />
          </Form.Item>
          <Form.Item
            name="vehicle_number"
            label="Vehicle Number"
            rules={[{ required: true, message: "Please enter the vehicle number" }]}
          >
            <Input placeholder="e.g. MH12AB1234" />
          </Form.Item>
          <Form.Item
            name="driver_number"
            label="Driver Number"
            rules={[{ required: true, message: "Please enter the driver number" }]}
          >
            <Input placeholder="e.g. 9876543210" />
          </Form.Item>
          <Button type="primary" htmlType="submit" block>
            Confirm Dispatch
          </Button>
        </Form>
      </Drawer>

      <Drawer
        title="Update Dispatch Time"
        open={!!dispatchTimeDrawerVisible}
        onClose={() => { setDispatchTimeDrawerVisible(null); dispatchTimeForm.resetFields(); }}
        width={400}
      >
        <Form
          form={dispatchTimeForm}
          layout="vertical"
          onFinish={(vals) => {
            if (!hasPermission("deliverydispatchdatetime.edit")) {
              message.error("You don't have permission to update dispatch time");
              return;
            }
            const chosenDate = vals.dispatch_date.format('YYYY-MM-DD');
            const leg_commited_dispatch_time = `${chosenDate}T03:30:00Z`;
            editDelivery({ id: dispatchTimeDrawerVisible?.id, leg_commited_dispatch_time })
              .then(() => fetchDeliveries({ keepCurrentSearch: true }));
            setDispatchTimeDrawerVisible(null);
            dispatchTimeForm.resetFields();
          }}
        >
          <Form.Item
            name="dispatch_date"
            label="Update dispatch time"
            rules={[{ required: true, message: "Please select a date" }]}
          >
            <DatePicker
              style={{ width: '100%' }}
              disabledDate={(current) => !!current && current.valueOf() <= dayjs().endOf('day').valueOf()}
            />
          </Form.Item>
          <Button type="primary" htmlType="submit" block>
            Confirm Date
          </Button>
        </Form>
      </Drawer>

      <EscalationDrawer
        data={escalationDrawerData}
        onClose={() => setEscalationDrawerData(null)}
        onSuccess={() => fetchDeliveries({ keepCurrentSearch: true })}
      />
    </>
  );
};
